<template>
  <div class="max-w-2xl mx-auto px-4 dark:bg-gray-900 dark:text-gray-300">
    <BizLabel>{{ $t("chat_with_us") }}</BizLabel>
    <div class="grid gap-2 lg:grid-cols-2">
      <BizContact
        v-for="(contact, i) in mobiles"
        :key="`contact-${i}`"
        :name="contact.name"
        :mobile="contact.mobileNumber"
        :desc="contact.designation"
        :profile="contact.profile"
        :whatsapp-support="contact.whatsappSupport"
        :call-support="contact.callSupport"
        :is-available="contact.isAvailable"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  computed: {
    ...mapState(useBizStore, ["mobiles"]),
  },
};
</script>
